import React from 'react';
import { Button, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

interface EditImageProps {
  id: string,
  accept?: string,
  maxWidth?: number,
  maxHeight?: number,
  aspectRatio?: number,
  src:string,
  onChange: (selectedFile: string) => void
}

export function EditImageButton(props: EditImageProps) {

  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [image, setImage] = React.useState<string>(props.src);
  const [pageState, setPageState] = React.useState<string>('imageSelected');
  const [aspectRatio, setAspectRatio] = React.useState<number>(props.aspectRatio ?? 1);

  const [cropData, setCropData] = React.useState('#');
  const [cropper, setCropper] = React.useState<any>();


  async function handleClose() {
    setOpenDialog(false);
  }

  async function updateFile() {
    const cropData = cropper.getCroppedCanvas().toDataURL();
    setCropData(cropData);

    setPageState('imageCropped');

  }

  async function saveFile() {

    if (cropData) {
      props.onChange(cropData);
    }

    setOpenDialog(false);
  }

  async function returnToEdit() {
    setPageState('imageSelected');
  }

  const onEdit = async ({ target }: any) => {
    setOpenDialog(true);
  }

  function isState(state: string): boolean {
    return state === pageState;
  }

  return (
    <>
      <Grid container>
        <Grid item xs={3}>
            <Button color="secondary" variant="contained" component="span" onClick={onEdit}>
              Edit Image
            </Button>
        </Grid>
      </Grid>

      <Dialog open={openDialog} sx={{ width: 800 }}  >
        <DialogTitle>Edit Image</DialogTitle>
        <DialogContent>
          {isState('imageSelected') && <Cropper
            src={image}
            style={{ height: 250, width: 250 }}
            aspectRatio={aspectRatio}
            guides={true}
            background={false}
            responsive={true}
            autoCropArea={1}
            checkOrientation={false}
            onInitialized={(instance) => {
              setCropper(instance);
            }}

          />}

          {isState('imageCropped') && <img alt='cropImage' src={cropData} style={{ width: 250 }} />}

        </DialogContent>
        <DialogActions>
          {isState('imageCropped') && <Button onClick={returnToEdit}>Undo</Button>}
          {isState('imageSelected') && <Button onClick={updateFile}>Update</Button>}
          {isState('imageCropped') && <Button onClick={saveFile}>Save</Button>}
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );

}